import React from 'react';
import axios from 'axios';
import isEqual from 'react-fast-compare';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import AnnouncementButton from '../parts/AnnouncementsButton';
import PupilCard from '../parts/PupilCard';
import AnnouncementCard from '../parts/AnnouncementCard';
import AbstractDashboardPage from './AbstractDashboardPage';
import { appColours } from '../../helpers';
import { setData } from '../../actions/index';
import {connect} from "react-redux";
import {withSnackbar} from "notistack";
import ParentVerifyEmail from '../parts/ParentVerifyEmail';

const colours = appColours();
const styles = theme => ({
  padding: {
    padding: 16,
  },
  noPupilsAlert: {
    fontSize: 24,
    padding: 20,
    backgroundColor: '#FF7171',
    color: '#ffffff',
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

class MobileDashboardPage extends AbstractDashboardPage {
  render() {
    const {
      isLoading,
      isLoaded,
      announcements,
      pupils,
    } = this.state;
    const {
      t,
      classes,
      user,
    } = this.props;

    return (
      <div className="mobile-dashboard-page">
        {isLoading && !isLoaded && (
            <CircularProgress />
        )}
        {!isLoading && isLoaded && !user && (
          <div className={classes.noPupilsAlert}>
            {t('Something went wrong. Please try to logout and login back again.')}
          </div>
        )}
        {!isLoading && isLoaded && user && user.isEmailVerified && pupils.length === 0 && (
          <div className={classes.noPupilsAlert}>
            {t('There are currently no pupils linked to your account. Please contact your school to request a new access code.')}
          </div>
        )}
        {!isLoading && isLoaded && user && !user.isEmailVerified && (
          <ParentVerifyEmail
            showForWhichPupils
            useSuspense={false}
          />
        )}
        {isLoaded && user && user.isEmailVerified && announcements.length > 0 && (
          <AnnouncementButton
            announcements={announcements}
            useSuspense={false}
          />
        )}
        {isLoaded && user && user.isEmailVerified && pupils.map((pupil, index) => {
          const colourIndex = index % colours.length;
          return (
            <PupilCard
              key={pupil.id}
              pupil={pupil}
              colourIndex={colourIndex}
              useSuspense={false}
            />
          );
        })}
        {isLoaded && user && user.isEmailVerified && announcements.map((announcement) => {
          if (
            announcement.state === 'dismissed'
                && announcement.sticky === 'no'
          ) {
            return;
          }

          return (
            <AnnouncementCard
              key={announcement.id}
              announcement={announcement}
              onClose={() => { this.updateData(); }}
              showForWhichPupils
              useSuspense={false}
            />
          );
        })}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withStyles(styles)(withSnackbar(withTranslation()(MobileDashboardPage)))
);
